import axios from 'axios'
import { setupInterceptorsTo } from './helper.js'

const omniApi = setupInterceptorsTo(
  axios.create({
    baseURL: process.env.REACT_APP_OMNI_BASEURL,
    headers: {
      'Content-Type': 'application/json',
    },
  }),
  'OMNI',
)

export async function getOmni(url, config = {}) {
  return await omniApi
    .get(url, {
      ...config,
    })
    .then((response) => response.data)
    .catch((e) => {
      console.error(e)
      return e
    })
}

export async function postOmni(url, data, config = {}) {
  return omniApi
    .post(url, { ...data }, { ...config })
    .then((response) => {
      return response.data
    })
    .catch((e) => {
      console.error(e)
      return e.response
    })
}

export async function putOmni(url, data, config = {}) {
  return omniApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data)
    .catch((e) => {
      console.error(e)
      return e
    })
}
